import { Form } from '@/components';
import { useHomeLookupSource } from '@/views';
import { useField } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface HomeInputProps {
  communityId: string;
  projectId: string;
  name: string;
  isTemplate?: boolean;
  onChanged?: (homeIds: string[]) => void;
}

export function HomeInput(props: HomeInputProps) {
  const { communityId, name, projectId, isTemplate, onChanged } = props;
  const homeDataSource = useHomeLookupSource(communityId, projectId);

  const [, { value: selectedHomeIds }] = useField<string[]>(`${name}.homeIds`);

  useEffect(() => {
    isTemplate && onChanged && onChanged(selectedHomeIds);
  }, [selectedHomeIds, isTemplate, name, onChanged]);

  const { t } = useTranslation();

  return (
    <Form.AsyncSelect
      name={`${name}.homeIds`}
      dataSource={homeDataSource}
      label={false}
      preload
      mode="multiple"
      selectAll={{
        selectAllLabel: t('personalization.selectAll'),
        unselectAllLabel: t('personalization.unselectAll'),
      }}
    />
  );
}
